// Form Upsell Cart Method
window.addEventListener("load", (event) => {
  const upsellContainer = document.querySelector("#CartDrawer");

  if (upsellContainer) {
    upsellContainer.addEventListener("click", function (event) {
      if (event.target && event.target.matches(".upsell_atc-btn")) {
        event.preventDefault();

        const productContainer = event.target.closest(".cart_upsell-item");

        if (productContainer) {
          const checkedRadio = productContainer.querySelector(
            'input[type="radio"]:checked'
          );

          if (checkedRadio) {
            const productId = productContainer.getAttribute("data-product-id");
            const variantId = checkedRadio.getAttribute("data-variant");

            // console.log(
            //   `Product added: productId=${productId}, variantId=${variantId}`
            // );

            const lineItems = [
              {
                id: variantId,
                quantity: 1,
              },
            ];

            // console.log("Line items for cart: ", lineItems);

            // Send the data to the cart via AJAX
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({ items: lineItems }),
            })
              .then((response) => response.json())
              .then((data) => {
                // Optionally redirect to the cart or update the cart UI
                // console.log("Cart updated: ", data);
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    bubbles: true,
                  })
                );
              })

              .catch((error) => {
                // Handle errors
                console.error(error);
              });
          } else {
            console.log("No radio button selected for this product");
          }
        } else {
          console.log("Product container not found");
        }
      }
    });
  }
});

// Mobile Upsell Cart Script
document.addEventListener("DOMContentLoaded", (event) => {
  function runAt(selector, callback) {
    const interval = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(interval);
        callback();
      }
    }, 100);
  }

  function getSelectors(parentElement = document) {
    return {
      upsellContainer: parentElement.querySelector(".mobile-upsell_products"),
      upsellItems: parentElement.querySelectorAll(".mobile-upsell--item"),
    };
  }

  function colorButtons() {
    const selectors = getSelectors();
    if (selectors.upsellContainer) {
      selectors.upsellItems.forEach((upsellItem) => {
        const colorOptions = upsellItem.querySelectorAll(".color--option");

        colorOptions.forEach((colorOption) => {
          if (colorOption) {
            firstColor = colorOption;
          }
          colorOption.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();

            colorOptions.forEach((option) => option.classList.remove("active"));

            this.classList.add("active");

            const productData = JSON.parse(this.getAttribute("data-product"));
            //console.log("Active Product Data:", productData);
            updateUpsellDetails(upsellItem, productData);
          });
        });

        // Automatically select the first available size on page load
        if (colorOptions) {
          colorOptions[0].click();
        }
      });
    }
  }

  function updateUpsellDetails(upsellItem, productData) {
    const selectors = getSelectors();

    // Extract relevant values
    const productImage = productData?.featured_image
      ? `${productData.featured_image}&width=700`
      : "";
    const productTitle = productData?.title || "No Title";
    const productHandle = productData?.handle || "";
    const productUrl = `/products/${productHandle}`;
    const productPrice = productData?.price
      ? theme.Currency.formatMoney(
          productData.price,
          theme.settings.moneyFormat
        )
      : "No Price";
    const productVariants = productData?.variants || [];

    // Find elements within the specific upsell item
    const upsellImage = upsellItem.querySelector(".upsell--image");
    const upsellTitle = upsellItem.querySelector(".upsell--title");
    const upsellPrice = upsellItem.querySelector(".upsell--price");
    const upsellVariants = upsellItem.querySelector(".upsell--size_variants");

    // Update UI elements for this upsell item only
    if (upsellImage) upsellImage.src = productImage;
    if (upsellTitle) upsellTitle.textContent = productTitle;
    if (upsellPrice) upsellPrice.textContent = productPrice;

    const upsellLinks = upsellItem.querySelectorAll("a");
    upsellLinks.forEach((link) => {
      link.href = productUrl;
    });

    if (upsellVariants) {
      upsellVariants.innerHTML = variantOptions(productVariants);
      addVariantClickEvents(upsellItem);
    }
    attachUpsellAddToCartListener(upsellItem);
  }

  function variantOptions(variants) {
    if (!variants.length) return "<p>No variants available</p>";

    let variantHTML = "";
    variants.forEach((variant) => {
      variantHTML += `
      <button class="variant-button" data-variant-id="${variant.id}" ${
        variant.available ? "" : "disabled"
      }>
        ${variant.title}
      </button>
    `;
    });

    return variantHTML;
  }

  function addVariantClickEvents(upsellItem) {
    const variantButtons = upsellItem.querySelectorAll(".variant-button");
    let firstVariant = null;
    let selectedValue = upsellItem.dataset.selectedVariant || "";

    variantButtons.forEach((variant) => {
      const variantTitle = variant.textContent.trim();

      // ✅ If previously selected variant matches, auto-select it
      if (selectedValue && variantTitle === selectedValue) {
        firstVariant = variant;
      }

      if (!variant.disabled && !firstVariant) {
        firstVariant = variant;
      }
      variant.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        variantButtons.forEach((btn) => btn.classList.remove("active"));

        this.classList.add("active");

        selectedValue = this.textContent.trim();
        upsellItem.dataset.selectedVariant = selectedValue;

        //console.log("Selected Variant ID:", selectedVariantId);
      });
    });

    // Automatically select the first available size on page load
    if (firstVariant) {
      firstVariant.classList.add("active");
      firstVariant.click();
    }
  }

  function attachUpsellAddToCartListener(upsellItem) {
    const atcButton = upsellItem.querySelector(".upsell--atc_button");
    if (!atcButton) return;

    const newButton = atcButton.cloneNode(true);
    atcButton.parentNode.replaceChild(newButton, atcButton);

    newButton.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const activeVariant = upsellItem.querySelector(".variant-button.active");
      if (!activeVariant) {
        console.error("No variant selected!");
        return;
      }

      const variantId = activeVariant.getAttribute("data-variant-id");

      // Prepare item data for Shopify cart API
      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 422) {
            console.error("Error adding to cart:", data);
          } else {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                bubbles: true,
              })
            );
            //console.log("Item added to cart:", data);
          }
        })
        .catch((error) => {
          console.error("Error adding item to cart:", error);
        });
    });
  }

  function globalFunction() {
    var mobileUpsellSwiper = new Swiper(".mobile-upsell--slider", {
      slidesPerView: 1.15,
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next.swiper-button",
        prevEl: ".swiper-button-prev.swiper-button",
      },
      breakpoints: {
        767: {
          slidesPerView: 1.25,
        },
      },
    });
    // Other Functions
    colorButtons();
  }

  function init() {
    runAt("#CartDrawer", globalFunction);
  }

  init();
});
